import Model from '@/Models/Contracts/Model';
export default class Import extends Model {
    resource() {
        return 'imports';
    }
}
